export default __webpack_public_path__ + "static/media/tessa.c73737ff.jpeg";